import { Component, OnInit, Input } from '@angular/core';
import { SlicePipe } from '@angular/common';
import { Shared } from '../shared.service';

@Component({
  selector: 'print-menu-item',
  templateUrl: './print-menu-item.component.html',
  styleUrls: ['./print-menu-item.component.scss']
})
export class PrintMenuItemComponent implements OnInit {

  @Input() product;
  @Input() layout;
  @Input() i;
  canSee = false;
  modifiedDescription;
  
  
  constructor(public shared: Shared) { 
  	
  }

  ngOnInit() {
    this.cutDescription();
    this.hasProductType();
  }

  hasProductType(){
    if (this.product.type == null || this.product.type == undefined || !this.product.type){
      return false;
    }
    return true;
  }

  cutDescription(){
    if(this.product.description.length <= 150){
      this.modifiedDescription = this.product.description;
    }else{
      this.modifiedDescription = this.product.description.slice(0, 150)+'...';
    }
  }

  seeTier(tier){
      if(tier.price === ''){
          this.canSee = true;
          return false;
      } else {
          this.canSee = false;
          return true;
      }
  }

  isSoldOut(tier){
      if(tier.soldOut === undefined){
          return false;
      }
      return tier.soldOut[this.shared.firebase_user.location] === true;
  }

  getSale(tier){
      if(this.product.sale.active){
          switch(this.product.sale.measurement){
              case '$':
                  return Number(this.product.sale.value);
              case '%':
                  return tier.price * (Number(this.product.sale.value)/100);
              default:
                  return 0;
          }
      } else if(this.shared.noGlobalSale){
          return 0;
      } else {
          switch(this.shared.globalSale.measurement){
              case '$':
                  return Number(this.shared.globalSale.value);
              case '%':
                  return tier.price * (Number(this.shared.globalSale.value)/100);
              default:
                  return 0;
          }
      }
  }

}



// WEBPACK FOOTER //
// ./src/app/print-menu-item/print-menu-item.component.ts